module.exports = __webpack_public_path__ + "img/chrome-250.dbc55e2d.png";